var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.75,
    y: 74.65,
    width: 164.45,
    height: 145.92,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.86,
    y: 78.65,
    width: 156,
    height: 138,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.48 78.65 283.86 216.35 283.86 151.65 303.19 78.65 320.48 78.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.44 78.65 296.51 216.65 290.62 216.65 327.55 78.65 333.44 78.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.86 165.73 439.86 187.78 432.39 216.65 426.5 216.65 439.86 165.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.65,
    y: 76.17,
    width: 2.63,
    height: 143.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.57,
    y: 76.17,
    width: 2.63,
    height: 143.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 301.05,
    width: 90.67,
    height: 81.31,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 301.05,
    width: 31.56,
    height: 81.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 221.41,
    width: 90.67,
    height: 81.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 221.41,
    width: 31.56,
    height: 81.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 140.34,
    width: 90.67,
    height: 81.31,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 140.34,
    width: 31.56,
    height: 81.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.13,
    y: 301.12,
    width: 90.67,
    height: 81.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.13,
    y: 301.12,
    width: 31.56,
    height: 81.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.17,
    y: 251.87,
    width: 90.67,
    height: 50.93,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.17,
    y: 251.87,
    width: 31.56,
    height: 50.93,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.13,
    y: 171.41,
    width: 58.58,
    height: 81.31,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.13,
    y: 171.41,
    width: 20.39,
    height: 81.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.51,
    y: 301.19,
    width: 90.67,
    height: 81.31,
    transform: "translate(783.69 683.7) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.63,
    y: 301.19,
    width: 31.56,
    height: 81.31,
    transform: "translate(842.81 683.7) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.47,
    y: 236.68,
    width: 90.67,
    height: 66.19,
    transform: "translate(747.6 539.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.58,
    y: 236.68,
    width: 31.56,
    height: 66.19,
    transform: "translate(806.72 539.55) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.75,
    y: 204.28,
    width: 87.44,
    height: 32.4,
    transform: "translate(786.93 440.96) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.75,
    y: 204.28,
    width: 30.43,
    height: 32.4,
    transform: "translate(843.94 440.96) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-9",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bubble-speech--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.5,
    y: 109.95,
    width: 36.89,
    height: 34.3,
    rx: 4.53,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.34,139.89s2.33,11.27,18.21,17.52c0,0-9.71-6.21-9.11-17.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "335.96 126.13 341.23 133.45 351.93 120.76",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.53,149.42c4.89,3.51,9.31,9.51,6,26.31s-4.15,20.8-4.15,20.8l-32-3.6s-1.5-14.87,1-28.86C366.76,146,378.21,139.13,392.53,149.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.5,242.25S349.66,300,346.77,323.73c-3.78,30.94-19.23,76.2-19.23,76.2l6.18,1.6s21.78-38.47,26-73.07c17.3-35.37,18.7-78.93,18.7-78.93Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,413.93a8.93,8.93,0,0,1,3.17-.8h0s3.8-2.24,7.56-10.92l4.24,0a3.5,3.5,0,0,1,3.25,2.33,2,2,0,0,1,.12.59,24.1,24.1,0,0,1-.33,3,84.9,84.9,0,0,1-2.47,10l-.72-.19,1.3-6.31c.44-2.15-1.82-.08-2.86,2.09S326.65,418,322,417C316.52,415.7,314.33,414.91,316,413.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.38,404.62c.8-2.05,1.82-5.72,1.82-5.72l-9.07-1.26s0,4.46-1.68,7.38C330.19,405,334.38,404.62,334.38,404.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.75,241.33s1.35,58.75,3.42,82.55c2.71,31.06-3.05,78.54-3.05,78.54l6.38.28s13.35-42.14,10.35-76.88c9.61-38.18,2-81.08,2-81.08Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,415.87a9,9,0,0,1,3.07-1.15h0s3.53-2.63,6.34-11.67l4.2-.48a3.49,3.49,0,0,1,3.49,2,1.9,1.9,0,0,1,.18.57,24.19,24.19,0,0,1,0,3.07,84.54,84.54,0,0,1-1.39,10.16l-.73-.1.61-6.42c.2-2.18-1.81.12-2.62,2.39s-2.17,4.6-6.93,4C362.88,417.57,360.61,417,362.2,415.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.43,404.62c.57-2.12,1.19-5.88,1.19-5.88l-9.15-.27s.48,4.43-.87,7.52C375.3,405.44,379.43,404.62,379.43,404.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.19,232.61,346.3,314.83s38.72,6,54.22,2.49c0,0,3.81-47.47-12.37-82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.4,203.54l-10.35-10.22s-.35-2.74-1.36-3.5-8.09-3.34-9-2.77-2.08,6.31-.86,7.36,7.67,2.39,8.33,2.28L320.39,210Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,184.91c-4.46,2.37-20.3,24.51-22.63,25.6s-20.16-13.36-20.16-13.36l-3,5.13S328.27,223,336.54,222s24.1-18.5,24.1-18.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,184.91c-4.46,2.37-20.3,24.51-22.63,25.6s-20.16-13.36-20.16-13.36l-3,5.13S328.27,223,336.54,222s24.1-18.5,24.1-18.5Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.63 197.7 316.39 196.53 313.14 202.03 314.31 204.28 317.63 197.7",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.28,209.91c3.7-3.53,6.36-6.46,6.36-6.46l-.28-4.4L359,194.78A17.55,17.55,0,0,0,354.28,209.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.94,231.77c-1.25-22-.69-34.12-.12-40.17.63-6.45,1.62-6.69,1.62-6.69s7-.68,13.07-.63a98.61,98.61,0,0,1,14,1.48,93.14,93.14,0,0,1,13,3.13c-.71,2-1.35,4-1.95,5.76-.79,2.39-1.5,4.6-2.15,6.67-1.2,3.86-2.14,7.2-2.88,10.19a111,111,0,0,0-3.33,23s7.69,20.1,9.19,34.85l-25.5,2.75-3.5-14.75-3.5,15.25-14.25-5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.94,231.77c-1.25-22-.69-34.12-.12-40.17.63-6.45,1.62-6.69,1.62-6.69s7-.68,13.07-.63a98.61,98.61,0,0,1,14,1.48,93.14,93.14,0,0,1,13,3.13c-.71,2-1.35,4-1.95,5.76-.79,2.39-1.5,4.6-2.15,6.67-1.2,3.86-2.14,7.2-2.88,10.19a111,111,0,0,0-3.33,23s7.69,20.1,9.19,34.85l-25.5,2.75-3.5-14.75-3.5,15.25-14.25-5Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.29,216.9c.34-1.68.74-3.47,1.23-5.39.31-1.22.65-2.5,1-3.86-1-3.41-2-.74-2-.74A30.79,30.79,0,0,0,391.29,216.9Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.86,185.62a8.47,8.47,0,0,1,.95-.41c.72-.57,1.6-1.94,1.56-5.27A28.7,28.7,0,0,0,375,176l9.27-1.73s-3.16,6.24-.53,10.88c.91.4,1.45,1,1.35,1.73-.69,5.35-12.21,10.53-12.21,10.53S367.27,188.69,372.86,185.62Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,176a28.7,28.7,0,0,1,.36,3.91c6.26,0,8.91-5.64,8.91-5.64Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.13,150.11c-8.06-.44-10.89,3.73-11.93,12-1.31,10.34.59,17.84,10.79,16.18C392.84,176,393.52,150.84,380.13,150.11Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,162a17,17,0,0,1-2.53,3.21,2.21,2.21,0,0,0,2.08,1Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.4,161.56c0,.66.26,1.23.7,1.26s.84-.47.9-1.13-.27-1.23-.71-1.26S378.45,160.9,378.4,161.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,160.47l-1.39-.67S378.7,161.06,379.47,160.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.19,160.78c-.05.66.26,1.22.7,1.26s.85-.47.9-1.14-.27-1.22-.71-1.26S370.24,160.12,370.19,160.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,159.69l-1.39-.68S370.49,160.28,371.26,159.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.79,156a4.18,4.18,0,0,1,3.42,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,155.34a3.76,3.76,0,0,0-3.25.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,164.18s-3.41-6.83-2.56-11.91c0,0-15.61-7.4-17.29,8.76,0,0-.77-14.48,13.1-14s12.7,20.71,5.22,26.36C386.67,173.35,390.3,168.45,388.2,164.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.79,165.81a3.54,3.54,0,0,1,4-3c2.48.41,3.39,5.61-2.89,6.5C387,169.41,386.53,168.51,386.79,165.81Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.27,168.07a6.49,6.49,0,0,1-4.63,1.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.64,152.27s-17.42-4.53-18.88,11.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,189.59s-1.33,13.24.85,25.29c0,0,5.14-18.62,12.36-24.95l-8.3,1.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,189.59s-1.33,13.24.85,25.29c0,0,5.14-18.62,12.36-24.95l-8.3,1.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,183.7,375,189.93v-6.62s-6.81,2.47-6.33,10l5.59-2.57v2.57l1.31-2.48,4.42,5.05s5.41-6.31,6-8.21S383.43,183.7,383.43,183.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,183.7,375,189.93v-6.62s-6.81,2.47-6.33,10l5.59-2.57v2.57l1.31-2.48,4.42,5.05s5.41-6.31,6-8.21S383.43,183.7,383.43,183.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23,242.12l-7.74-36.93a1.72,1.72,0,0,0-1.68-1.37H359a1.2,1.2,0,0,0-1.18,1.41l6.45,36.16a1.71,1.71,0,0,0,1.64,1.42l25.17.75A1.2,1.2,0,0,0,392.23,242.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.23,242.12l-7.74-36.93a1.72,1.72,0,0,0-1.68-1.37H359a1.2,1.2,0,0,0-1.18,1.41l6.45,36.16a1.71,1.71,0,0,0,1.64,1.42l25.17.75A1.2,1.2,0,0,0,392.23,242.12Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,230.16l-12.31-7.76s-.94-2.59-2.08-3.12-8.62-1.52-9.35-.77-.67,6.6.75,7.37,8,.68,8.62.43l13.79,10.56Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.51,188.89s-8,11.68-6.87,21.68l10.67,17.66-7.17-3.66-3.25,6.12s8.25,12.71,18.75,9.71S399.51,188.89,399.51,188.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.51,188.89s-8,11.68-6.87,21.68l10.67,17.66-7.17-3.66-3.25,6.12s8.25,12.71,18.75,9.71S399.51,188.89,399.51,188.89Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.89 224.23 392.81 231.82 391.89 229.65 395.14 223.48 396.89 224.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,203.82c-.94,0-.94,24.6-.94,24.6l-21.5-.62s-2.42-20.8,0-24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,203.82c-.94,0-.94,24.6-.94,24.6l-21.5-.62s-2.42-20.8,0-24Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.2,184.33l20.33,8.55a.91.91,0,0,1,.47,1.2h0a.89.89,0,0,1-1.17.46l-20.46-8.67-.19-.1L289.8,184l3.13.27A.88.88,0,0,1,293.2,184.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.75,226.47,206,228.23l-7.92-4.47s-25.4-14.15-32-18.62c-2-1.37-3.87-4.35-5.48-7.85a79.06,79.06,0,0,1-3.48-9.23c-.45-1.41-.85-2.76-1.19-4-.76-2.67-1.23-4.67-1.36-5.21h0a.49.49,0,0,0,0-.13h0l.05,0,6.26-2,5.23-1.66s.24,1.24.65,3.13l.36,1.67c.11.48.22,1,.34,1.52,1.32,5.82,3.35,13.76,4.82,15.06,2.37,2.09,32.17,22.4,33.23,22.93s10.55,0,10.55,0Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,150.68c9.1-.14,14.89,28.06,14.89,28.06l-12,6a38.42,38.42,0,0,1-5.15-19.42C152.43,154.5,154.41,150.68,154.41,150.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,150.68c9.1-.14,14.89,28.06,14.89,28.06l-12,6a38.42,38.42,0,0,1-5.15-19.42C152.43,154.5,154.41,150.68,154.41,150.68Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.63 179.29 167.39 181.39 163.16 184.13 157.08 188.06 155.99 188.77 154.67 184.76 155.89 184.1 156.69 183.66 162.25 180.63 166.69 178.2 168.91 176.99 169.3 176.78 170.63 179.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,188.77a12.92,12.92,0,0,1-3.14,8.52,79.06,79.06,0,0,1-3.48-9.23l-1.09.71-1.32-4,1.22-.66c-.76-2.67-1.23-4.67-1.36-5.21h0v-.16l1.44-11a53.58,53.58,0,0,1,4.82,9c.52,1.23,1,2.54,1.44,3.9q.23.7.42,1.44c.19.68.35,1.37.49,2.06A26,26,0,0,1,163.7,188.77Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.05 409.36 161.42 410.25 162.99 392.2 154.62 391.31 153.05 409.36",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.3 408.75 119.4 408.75 120.07 389.97 111.96 389.97 111.3 408.75",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.53,407.81h-9.85a.72.72,0,0,0-.69.56l-1.6,7.22a1.19,1.19,0,0,0,.92,1.42.78.78,0,0,0,.26,0c3.19,0,5.51-.24,9.51-.24,2.47,0,9.91.25,13.31.25s3.85-3.36,2.45-3.67c-6.25-1.36-11-3.25-13-5A2,2,0,0,0,120.53,407.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09,408.94a.2.2,0,0,1-.15-.17.18.18,0,0,1,.09-.18c.29-.19,2.91-1.8,3.81-1.33a.55.55,0,0,1,.33.53,1.15,1.15,0,0,1-.4,1,2.41,2.41,0,0,1-1.56.42A9.43,9.43,0,0,1,121.09,408.94Zm.55-.27a3.91,3.91,0,0,0,2.89-.15.81.81,0,0,0,.26-.69c0-.15-.07-.22-.13-.22a.4.4,0,0,0-.24-.05A7.81,7.81,0,0,0,121.64,408.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,409a.21.21,0,0,1-.09-.18c0-.11.21-2.44,1.15-3.2a1,1,0,0,1,.81-.25.63.63,0,0,1,.62.5c.16.86-1.46,2.64-2.29,3.1h-.09A.2.2,0,0,1,121,409Zm1.3-3.16a4.62,4.62,0,0,0-1,2.54c.84-.63,1.87-2,1.77-2.51,0-.05,0-.19-.28-.19h-.09A.7.7,0,0,0,122.33,405.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.3,407.56h-9.85a.71.71,0,0,0-.69.55l-1.6,7.22a1.2,1.2,0,0,0,.92,1.42l.27,0c3.18-.06,5.5-.25,9.51-.25,2.46,0,9.9.26,13.3.26s3.85-3.37,2.46-3.68c-6.25-1.36-11-3.24-13-5A2,2,0,0,0,162.3,407.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.86,408.68a.2.2,0,0,1-.15-.17.17.17,0,0,1,.1-.18c.29-.19,2.91-1.8,3.8-1.33a.57.57,0,0,1,.33.53,1.14,1.14,0,0,1-.4,1A2.47,2.47,0,0,1,165,409,9.51,9.51,0,0,1,162.86,408.68Zm.55-.27a4,4,0,0,0,2.89-.14.8.8,0,0,0,.26-.69c0-.16-.07-.23-.12-.23a.43.43,0,0,0-.25-.05A8,8,0,0,0,163.41,408.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,408.72a.21.21,0,0,1-.1-.17c0-.12.21-2.45,1.15-3.21a1,1,0,0,1,.81-.25.63.63,0,0,1,.62.51c.17.85-1.45,2.64-2.29,3.09h-.09A.19.19,0,0,1,162.81,408.72Zm1.3-3.16a4.54,4.54,0,0,0-1,2.54c.83-.63,1.86-2,1.76-2.5,0-.06,0-.2-.28-.2h-.09A.67.67,0,0,0,164.11,405.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.62 391.31 162.99 392.2 162.17 401.51 153.8 400.62 154.62 391.31",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.96 389.98 120.07 389.98 119.72 399.67 111.61 399.67 111.96 389.98",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,225.22h43c4.09,22.35,16.9,101.42,7.71,171.87l-14.57-1.81s1.35-93.53-11.51-128.1c-1.48,18.5-3.24,38.19-4.76,48.67C131.46,341.63,123.45,398,123.45,398H108.62s3-53.94,4.43-79.29C114.58,291.19,115.25,230.87,115.3,225.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,267.18a115.13,115.13,0,0,1,4.81,18.62c1.2-16.47-3.61-33.93-3.61-33.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 400.48 149.69 397.8 150.24 392.81 168.99 395.27 167.72 400.48",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 400.48 149.69 397.8 150.24 392.81 168.99 395.27 167.72 400.48",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.23 398.11 107.74 398.11 107.74 392.88 125.89 392.54 125.23 398.11",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.23 398.11 107.74 398.11 107.74 392.88 125.89 392.54 125.23 398.11",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.22 232.7 115.18 226.47 159.04 223.76 159.35 229.8 115.22 232.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.34,
    y: 224.89,
    width: 1.98,
    height: 9.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 221.9,
    width: 1.98,
    height: 9.13,
    transform: "translate(-16.07 11.96) rotate(-4.17)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,223.76,115.18,227c0-3.84-.1-8.12-.39-12.64-.54-8.35-1.57-17.49-2.72-26.06-2.44-18.21-5.43-33.84-5.43-33.84,20.4-5.15,47.77-3.81,47.77-3.81C161.52,177.29,159,223.76,159,223.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,223.76,115.18,227c0-3.84-.1-8.12-.39-12.64-.54-8.35-1.57-17.49-2.72-26.06-2.44-18.21-5.43-33.84-5.43-33.84,20.4-5.15,47.77-3.81,47.77-3.81C161.52,177.29,159,223.76,159,223.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,151.73c4,3.59,13.63,2.27,13.63,2.27s6-1.66,4.77-3.55c-3.56-.58-5.28-2.24-6-4.37a10.08,10.08,0,0,1-.36-4.06,19.32,19.32,0,0,1,.3-2.27l-12-8.86C124.16,136.74,126.08,147.49,122.21,151.73Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,136.52c.47,7.18,6.37,9.16,9.26,9.56a10.08,10.08,0,0,1-.36-4.06Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,113.83c2.91,2.76,1.7,11.17-4.23,15.47s-5.93-16.5-5.93-16.5S144.15,112.07,146,113.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55,138.18a10.14,10.14,0,0,0,11.65,3.93,11.28,11.28,0,0,0,6.44-5.25,11.89,11.89,0,0,0,.54-1.07C146.1,129,147,117,139.81,112.54A11,11,0,0,0,124.66,116a11.13,11.13,0,0,0-1.65,4.84C122.13,128.8,121.23,133.46,124.55,138.18Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,125.09c-.15.63.14,1.22.57,1.29s.85-.4,1-1-.15-1.22-.56-1.29S134.77,124.44,134.65,125.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.94,126.33c-.15.63.15,1.23.56,1.3s.86-.4,1-1-.15-1.23-.57-1.3S142.05,125.72,141.94,126.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,126.25a23.13,23.13,0,0,0,2.14,6,3.77,3.77,0,0,1-3.2.05Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.79,122.34a.44.44,0,0,0,.4-.08,3.07,3.07,0,0,1,2.64-.86.38.38,0,0,0,.46-.28.39.39,0,0,0-.28-.46h0a3.84,3.84,0,0,0-3.35,1,.39.39,0,0,0,0,.54h0A.49.49,0,0,0,132.79,122.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,135.5h0a5.85,5.85,0,0,1-4.77-2.6.2.2,0,0,1,.07-.28.2.2,0,0,1,.27.06v0a5.63,5.63,0,0,0,4.44,2.39.2.2,0,0,1,.2.19v0a.2.2,0,0,1-.19.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,124.35a.43.43,0,0,0,.22.06.4.4,0,0,0,.27-.47h0a3.78,3.78,0,0,0-2.36-2.59.38.38,0,0,0-.47.25h0a.39.39,0,0,0,.25.48h0a3.09,3.09,0,0,1,1.84,2.08A.38.38,0,0,0,145.5,124.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.51,111.94v3.56a2.64,2.64,0,0,0-1.72,3.14c.77,3.1-1.46,7.48-3.95,9,0,0,.08-1.29-1-1.12s-1.63,6.88.09,10.31c0,0-2.84-3.26-3.78-10.48-.88-6.68-.42-12.1,1.21-14.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,126.72a7.66,7.66,0,0,0,3.66,4.55c2.36,1.27,4.13-.71,4-3.24-.16-2.26-1.56-5.7-4.18-5.9S117.77,124.33,118.45,126.72Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.75,118s-2.47-5.93,4-10.28,21.82.72,22.9,4.25S136.12,121.91,119.75,118Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.72 148.04 133.51 153.4 134.85 146.08 141.71 150.54 141.71 159.89 134.45 155.56 129.35 163.2 119.28 152.14 123.72 148.04",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.28,
    y: 224.23,
    width: 10.04,
    height: 7.54,
    rx: 1.16,
    transform: "translate(-12.38 8.21) rotate(-3.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.72 148.04 133.51 153.4 134.85 146.08 141.71 150.54 141.71 159.89 134.45 155.56 129.35 163.2 119.28 152.14 123.72 148.04",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.51,212.46c-2.91,4.38-12.22,4.35-15.72,1.93-.54-8.35-1.57-17.49-2.72-26.06Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.18,178.74s2.07,13.48,4.1,16.11,44,25.58,44,25.58l14.51-1.05,6.67,7.65s-19.33,3-21.44,2.42a20.35,20.35,0,0,1-3.73-1.44s-44-17.33-47.7-21.29-7.91-24.29-7.91-24.29Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.64,154.49c7.68-1.6,11.65,30.27,11.65,30.27l-15.71,4S97.19,156.47,106.64,154.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.64,154.49c7.68-1.6,11.65,30.27,11.65,30.27l-15.71,4S97.19,156.47,106.64,154.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.66 188 119.28 183.78 119.28 186.81 102.45 191.69 101.66 188",
    style: {
      fill: "#407BFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,387V249.92a29,29,0,0,0-5.21-16.59L152,226.47h85.1l4.79,6.86a29,29,0,0,1,5.21,16.59V385.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.85,
    cy: 408.24,
    r: 8.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.26,408.24a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,347.26,408.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,341.79,410.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,341.79,410.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.85,
    cy: 408.24,
    r: 8.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,408.24a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,249.26,408.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,243.79,410.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,243.79,410.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,383.53v8.32a2.81,2.81,0,0,1-2.81,2.81H158.26a2.81,2.81,0,0,1-2.81-2.81v-8.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,383.53v8.32a2.81,2.81,0,0,1-2.81,2.81H158.26a2.81,2.81,0,0,1-2.81-2.81v-8.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,383.53v8.32a2.81,2.81,0,0,1-2.81,2.81H158.26a2.81,2.81,0,0,1-2.81-2.81v-8.32Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.85,
    cy: 408.24,
    r: 8.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.26,408.24a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,276.26,408.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,270.79,410.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,270.79,410.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.85,
    cy: 408.24,
    r: 8.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.26,408.24a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,178.26,408.24Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,172.79,410.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,410.2h0a3.36,3.36,0,0,1-3.15-2.2l-5.19-14.22h11.69v13.07A3.35,3.35,0,0,1,172.79,410.2Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.84,
    y: 318.98,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.84,
    y: 318.98,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.84,
    y: 318.98,
    width: 43.27,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.69,
    y: 369.88,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.93,
    y: 369.88,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.77,
    y: 318.98,
    width: 5.27,
    height: 6.73,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.15,
    y: 346.54,
    width: 36.3,
    height: 8.44,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.66,
    y: 322.34,
    width: 12.41,
    height: 12.41,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.36,
    y: 254.43,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.36,
    y: 254.43,
    width: 93.25,
    height: 64.55,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.36,
    y: 254.43,
    width: 43.27,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.22,
    y: 305.33,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.46,
    y: 305.33,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.29,
    y: 254.43,
    width: 5.27,
    height: 6.73,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.67,
    y: 281.99,
    width: 36.3,
    height: 8.44,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.19,
    y: 257.79,
    width: 12.41,
    height: 12.41,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.44,
    y: 254.43,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.44,
    y: 254.43,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.44,
    y: 254.43,
    width: 43.27,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.3,
    y: 305.33,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.54,
    y: 305.33,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.37,
    y: 254.43,
    width: 5.27,
    height: 6.73,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.75,
    y: 281.99,
    width: 36.3,
    height: 8.44,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.27,
    y: 257.79,
    width: 12.41,
    height: 12.41,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.19,
    y: 189.88,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.19,
    y: 189.88,
    width: 43.27,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.04,
    y: 240.78,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.29,
    y: 240.78,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.12,
    y: 189.88,
    width: 5.27,
    height: 6.73,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 217.44,
    width: 36.3,
    height: 8.44,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 193.24,
    width: 12.41,
    height: 12.41,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 318.98,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 318.98,
    width: 93.25,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 318.98,
    width: 43.27,
    height: 64.55,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.03,
    y: 369.88,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.27,
    y: 369.88,
    width: 7.25,
    height: 9.23,
    rx: 0.92,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.11,
    y: 318.98,
    width: 5.27,
    height: 6.73,
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.49,
    y: 346.54,
    width: 36.3,
    height: 8.44,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 322.34,
    width: 12.41,
    height: 12.41,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrlogo);
export default __webpack_public_path__ + "static/media/Orlogo.3ee48ef202c3df430e71b3ea72a2e343.svg";
export { ForwardRef as ReactComponent };